import React from "react";
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from "@mui/material";
import StatusChip from "../common/StatusChip";
import RowMenu from "../common/RowMenu";

const BookingTable = ({ bookings, onAction }) => {
  return (
    <TableContainer component={Paper} elevation={0} sx={{ border: '1px solid #e0e0e0' }}>
      <Table>
        <TableHead sx={{ bgcolor: '#fafafa' }}>
          <TableRow>
            <TableCell sx={{ fontWeight: 'bold' }}>BOOKING ID</TableCell>
            <TableCell sx={{ fontWeight: 'bold' }}>CLIENT NAME</TableCell>
            <TableCell sx={{ fontWeight: 'bold' }}>CLIENT EMAIL</TableCell>
            <TableCell sx={{ fontWeight: 'bold' }}>BOOKING TIME</TableCell>
            <TableCell sx={{ fontWeight: 'bold' }}>SPECIALIST</TableCell>
            <TableCell sx={{ fontWeight: 'bold' }}>STATUS</TableCell>
            <TableCell sx={{ fontWeight: 'bold' }}>ACTION</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {bookings.map((row) => (
            <TableRow key={row.id} hover>
              <TableCell>{row.id}</TableCell>
              <TableCell>{row.clientName}</TableCell>
              <TableCell>{row.clientEmail}</TableCell>
              <TableCell>{row.timeLabel}</TableCell>
              <TableCell>{row.assignedEmployeeName || '—'}</TableCell>
              <TableCell>
                <StatusChip status={row.status} />
              </TableCell>
              <TableCell>
                <RowMenu 
                    actions={[
                        { label: 'View', onClick: () => onAction('view', row) },
                        { label: 'Edit', onClick: () => onAction('edit', row) },
                        { 
                            label: 'Confirm', 
                            onClick: () => onAction('confirm', row),
                            disabled: row.status === 'confirmed' 
                        },
                        { 
                            label: 'Cancel', 
                            onClick: () => onAction('cancel', row),
                            disabled: row.status === 'cancelled',
                            color: 'error.main'
                        },
                        {
                            label: 'Assign Employee',
                            onClick: () => onAction('assign', row),
                            disabled: row.status === 'cancelled'
                        }
                    ]} 
                />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default BookingTable;
